// This file is auto-generated. Do not edit directly.
import { Article } from '../types/article';

export const articles: Article[] = [
  {
    "id": "webp-the-modern-web-format",
    "slug": "webp-the-modern-web-format",
    "languages": [
     "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "svg-the-scalable-vector-graphics-format",
    "slug": "svg-the-scalable-vector-graphics-format",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "png-the-lossless-web-standard",
    "slug": "png-the-lossless-web-standard",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "optimizing-images-for-mobile-devices",
    "slug": "optimizing-images-for-mobile-devices",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "jpg-the-universal-image-format",
    "slug": "jpg-the-universal-image-format",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "gif-the-animated-format-that-defined-the-early-web",
    "slug": "gif-the-animated-format-that-defined-the-early-web",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "choosing-right-image-format",
    "slug": "choosing-right-image-format",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  },
  {
    "id": "avif-the-next-generation-format",
    "slug": "avif-the-next-generation-format",
    "languages": [
      "en", "es", "de", "cs", "it"
    ]
  }
];
